var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolumemute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M291.1,8.9c-4.9-4.1-11.3-5.7-17.5-4.6c-64,11.8-122.8,49.1-161.2,102.3h-5.8C47.8,106.6,0,154.5,0,213.3v85.4 c0,58.8,47.9,106.7,106.7,106.7h5.8c38.4,53.2,97.2,90.5,161.2,102.3c1.3,0.2,2.6,0.4,3.9,0.4c4.9,0,9.8-1.7,13.7-4.9 c4.9-4.1,7.7-10.1,7.7-16.4V25.3C298.8,19,296,13,291.1,8.9z M506.3,304.9c8.3,8.3,8.3,21.8,0,30.2c-4.2,4.2-9.6,6.3-15.1,6.3 c-5.5,0-10.9-2.1-15.1-6.3l-48.9-48.9l-48.9,48.9c-4.2,4.2-9.6,6.3-15.1,6.3c-5.5,0-10.9-2.1-15.1-6.3c-8.3-8.3-8.3-21.8,0-30.2 l48.9-48.9l-48.9-48.9c-8.3-8.3-8.3-21.8,0-30.2c8.3-8.3,21.8-8.3,30.2,0l48.9,48.9l48.9-48.9c8.3-8.3,21.8-8.3,30.2,0 c8.3,8.3,8.3,21.8,0,30.2L457.4,256L506.3,304.9L506.3,304.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumemute);
export default __webpack_public_path__ + "static/media/volumemute.89a0b63843bb9b0c4e680a1cbd2c4bce.svg";
export { ForwardRef as ReactComponent };